export const ExternalBotEvent = {
  ARTICLE_PAGE_INTERACTION: 'external.sys.article_page_interaction',
  CANCEL_SUPPORT_REQUEST: 'external.sys.cancel_support_request',
  APPLY_METADATA_AUTOMATION: 'external.sys.apply_metadata_automation',
  RESTART_CHAT: 'external.sys.restart_chat',
  RESTART_CHAT_RESOLUTION: 'external.sys.restart_chat_resolution',
  USER_LOGIN: 'external.sys.user_login',
  GUEST_LOGIN: 'external.sys.guest_login',
  END_LIVE_CHAT: 'external.sys.end_live_chat',
  END_VOICE_CALL: 'external.sys.end_voice_call',
  RESUME_LIVE_CHAT: 'external.sys.resume_live_chat',
  LOW_CSAT_CONNECT: 'external.sys.low_csat_connect',

  USER_SUBMIT_INPUT_TRANSACTION: 'external.user.submit_transaction',
  USER_SUBMIT_INPUT_TRANSACTION_FOR_AI: 'external.user.submit_transaction_for_ai',
  USER_SELECTED_TRANSACTION_LIST: 'external.user.selected_transaction_list',
  USER_EDIT_SELECTED_TRANSACTION: 'external.user.edit_selected_transaction',
  USER_SELECTED_CONNECT_OPTION: 'external.user.selected_connect_option',
  USER_MESSAGE_FOR_AI: 'external.user.message_for_ai',
  USER_FILE_FOR_AI: 'external.user.file_for_ai',
  AI_MESSAGE_FOR_USER: 'external.ai.message_for_user',
  RESUME_AI_CHAT: 'external.ai.resume_ai_chat',
  START_SELECTED_ENTITY_FLOW: 'external.sys.ai.start_selected_entity_flow',
  START_KYC_FLOW: 'external.sys.ai.start_kyc_flow',
  AI_CHAT_INTERVENE: 'external.ai.chat_intervene',
} as const;

export const ArticleInteractionType = {
  SUPPORT_REQUEST: 'support-request',
  EXECUTE_ACTION: 'execute-action',
  RESTART_CHAT: 'restart-chat',
  GO_TO_MY_REQUESTS: 'go-to-my-requests',
  BACK: 'back',
} as const;

export type ArticleInteraction = (typeof ArticleInteractionType)[keyof typeof ArticleInteractionType];
export type ExternalBotEventKind = (typeof ExternalBotEvent)[keyof typeof ExternalBotEvent];
